/** Gender — Male / Female radio (defaults to Male, like Android). */
import { Gender } from '../validation'
import { FieldLabel } from './FieldLabel'

interface Props {
  value: Gender
  onChange: (value: Gender) => void
}

const OPTIONS: { value: Gender; label: string }[] = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
]

export function GenderRadio({ value, onChange }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel required>Gender</FieldLabel>
      <div className="flex items-center gap-8">
        {OPTIONS.map((option) => {
          const selected = value === option.value
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className="flex items-center gap-2"
              aria-pressed={selected}
            >
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                  selected ? 'border-textAccentPrimary' : 'border-textSeparator'
                }`}
              >
                {selected && <span className="h-2.5 w-2.5 rounded-full bg-textAccentPrimary" />}
              </span>
              <span
                className={`text-labelLarge ${selected ? 'text-textPrimary' : 'text-textSecondary'}`}
              >
                {option.label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
